module.exports = __webpack_public_path__ + "index6.3aa43196.png";